<div class="w-full md:flex-none md:w-full pl-0 pr-0">
    <mat-form-field appearance="outline" class="mt-2 mb-1 w-full no-padding">
        <mat-label>Filter by contact</mat-label>
        <input matInput type="text" placeholder="Filter by contact" [(ngModel)]="contactsFilter">
        <fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
    </mat-form-field>
</div>
<div class="table-scroll border-t sticky sticky-crm mb-1">
    <table class="border border-t-0 si-table si-table--striped si-table--hover">
        <thead>
            <tr>
                <th class="flex-none w-7/12 align-middle px-2">
                    <mat-checkbox
                        title="Select All"
                        class="checkbox-label-font-weight-700"
                        [ngModel]="isSelectedAll"
                        (ngModelChange)="toggleSelectAll($event)"
                    >Select All</mat-checkbox>&nbsp;|&nbsp;<span class="a cursor-pointer font-normal" (click)="onClearAll()">Clear</span>
                </th>
                <th class="flex-none w-1/3 pr-0">
                    <div>
                        <div *ngIf="type !== 'outreach'">
                            <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                                <mat-label>Link Cadence</mat-label>
                                <mat-select placeholder="Link Cadence" [(ngModel)]="ddSelectedItem" (selectionChange)="onDDCadence()" [disabled]="showLinkCadence===false" #siSelectRef="matSelect">
                                    <mat-option *ngFor="let option of optionsList" [value]="option">{{option.name}}</mat-option>
                                </mat-select>
                                <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                            </mat-form-field>
                        </div>
                        <div *ngIf="type === 'outreach'">
                            <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                                <mat-label>Link Sequence</mat-label>
                                <mat-select placeholder="Link Sequence" [(ngModel)]="ddSelectedItem" (selectionChange)="onDDCadence()" [disabled]="showLinkCadence===false" #siSelectRef2="matSelect">
                                    <mat-option *ngFor="let option of optionsList" [value]="option">{{option.name}}</mat-option>
                                </mat-select>
                                <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef2.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                            </mat-form-field>
                        </div>
                    </div>
                </th>
                <th class="flex-none w-1/12 px-2"></th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let contact of selectedContacts | filterBy : contactsFilter">
                <td class="pb-0">
                    <div class="flex">
                        <div class="pr-4">
                            <mat-checkbox
                                title="Select"
                                [(ngModel)]="contact.selectedContact"
                                (change)="checkIfSelectedAll();"
                                (click)="$event.stopPropagation();"
                            ></mat-checkbox>
                        </div>
                        <div class="flex-none w-11/12 pl-0"><label class="mb-0">{{contact.name}}</label><br />
                            {{contact.jobTitle}} at {{contact.companyName}}</div>
                    </div>
                </td>
                <td class="pr-0">
                    <div *ngIf="type === 'salesloft'">
                        <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                            <mat-select [(ngModel)]="contact.selectedCadence" (selectionChange)="onMapCadence(contact.matchId, contact.selectedCadence)" [disabled]="contact.selectedContact === true" #siSelectRef3="matSelect">
                                <mat-option [value]="option.id" *ngFor="let option of optionsList">{{ option.name }}</mat-option>
                            </mat-select>
                            <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef3.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                        </mat-form-field>
                    </div>
                    <div *ngIf="type === 'outreach'">
                        <mat-form-field appearance="outline" class="mb-2 w-full no-padding">
                            <mat-select [(ngModel)]="contact.selectedSequence" (selectionChange)="onMapCadence(contact.matchId, contact.selectedSequence)" [disabled]="contact.selectedContact === true" #siSelectRef4="matSelect">
                                <mat-option [value]="option.id" *ngFor="let option of optionsList">{{ option.name }}</mat-option>
                            </mat-select>
                            <fa-icon matSuffix aria-hidden="true" class="si-icon si-select-arrow" [class.si-select-arrow--open]="siSelectRef4.panelOpen" [icon]="['fal', 'chevron-down']"></fa-icon>
                        </mat-form-field>
                    </div>
                </td>
                <td class="px-6 align-middle" [hidden]='type !== "salesloft"'>
                    <button matIconButton class="mat-error" [disabled]="contact.selectedContact === true" (click)="onClear(contact.matchId)"
                        [hidden]='!contact.selectedCadence'>
                        <fa-icon class="si-icon" [icon]="['fal', 'circle-xmark']"></fa-icon>
                    </button>
                </td>
                <td class="px-6 align-middle" [hidden]='type !== "outreach"'>
                    <button matIconButton class="mat-error" [disabled]="contact.selectedContact === true" (click)="onClear(contact.matchId)"
                        [hidden]='!contact.selectedSequence'>
                        <fa-icon class="si-icon" [icon]="['fal', 'circle-xmark']"></fa-icon>
                    </button>
                </td>
            </tr>
            <tr *ngIf="(selectedContacts | filterBy: contactsFilter).length === 0">
                <td colspan="2" class="w-full sm:flex-none sm:w-full text-center bg-white py-6 px-2"><i>No
                        Cadences Found</i></td>
            </tr>
        </tbody>
    </table>
</div>
